import { Fragment, FunctionalComponent, h } from 'preact';

import { IRoutingConfig } from '../../interfaces/routing';

import styles from './style.scss';

interface IProps {
    currentUrl: string;
    routingConfig: IRoutingConfig;
}

const Breadcrumbs: FunctionalComponent<IProps> = ({ currentUrl, routingConfig }) => {
    const breadcrumbs: { path: string; breadcrumb: string }[] = [];
    let path: string | null = currentUrl;

    while (path) {
        if (!routingConfig[path]) {
            break;
        }

        breadcrumbs.unshift({
            path,
            breadcrumb: routingConfig[path].breadcrumb,
        });

        path = routingConfig[path].parent ?? null;
    }

    return breadcrumbs.length > 1
        ? <p className={styles.breadcrumbs}>{ breadcrumbs.map((item, index) => (
            index === breadcrumbs.length - 1
                ? <span> { item.breadcrumb }</span>
                : <Fragment>
                    <a href={item.path}>{ item.breadcrumb }</a> &gt;
                </Fragment>

        )) }</p>
        : null;
};

export default Breadcrumbs;
